module.exports = __webpack_public_path__ + "img/luthi-7.5e83e769.jpg";